"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONRPC = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const CodedError_1 = require("./CodedError");
class JSONRPC {
    constructor(url) {
        this.url = url;
        this.id = 0;
    }
    request(method, params = []) {
        return (0, cross_fetch_1.default)(this.url, {
            method: 'POST',
            body: JSON.stringify({
                jsonrpc: '2.0',
                id: this.id++,
                method,
                params,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(res => res.json())
            .then(res => {
            if (res.error) {
                throw new CodedError_1.CodedError(res.error.message, res.error.code);
            }
            if (res.result.errno) {
                throw new CodedError_1.CodedError(res.result.errmsg, res.result.errno);
            }
            return res.result;
        });
    }
}
exports.JSONRPC = JSONRPC;
//# sourceMappingURL=JSON-RPC.js.map